const WHATSAPP_URL = 'https://wa.me/903222286464';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20phone%20case%20store%20interior%20with%20colorful%20iPhone%20cases%20displayed%20on%20wall%2C%20neon%20orange%20lighting%2C%20street%20style%20urban%20vibe%2C%20dark%20moody%20atmosphere%2C%20young%20trendy%20customers%20browsing%2C%20professional%20store%20photography%20with%20dramatic%20lighting&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Mağaza"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/30" />
      </div>

      {/* Orange accent glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-white/[0.02] rounded-full blur-3xl pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 sm:px-6 max-w-4xl mx-auto pt-20">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white/70 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-6 backdrop-blur-sm">
          <span className="w-2 h-2 bg-[#FF4500] rounded-full animate-pulse inline-block" />
          Adana'nın En Trend Aksesuar Mağazası
        </div>

        {/* Main Title */}
        <h1
          className="font-black uppercase leading-none text-white mb-4"
          style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: 'clamp(3.5rem, 12vw, 8rem)',
            letterSpacing: '0.02em',
            textShadow: '0 0 40px rgba(255,69,0,0.3)',
          }}
        >
          Telefonuna{' '}
          <span className="text-[#FF4500]">Tarz</span>{' '}
          Kat!
        </h1>

        {/* Subtitle */}
        <p className="text-white/75 text-base md:text-xl font-medium max-w-xl mx-auto mb-10 leading-relaxed">
          iPhone kılıfları, kişiye özel baskı ve en yeni aksesuarlar burada.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#ozel-baski"
            className="flex items-center gap-2.5 bg-[#FF4500] hover:bg-[#e03d00] text-white px-8 py-4 rounded-full text-base font-bold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-[#FF4500]/30"
          >
            <i className="ri-paint-brush-line w-5 h-5 flex items-center justify-center" />
            Kılıfını Tasarla
          </a>
          <a
            href="https://wa.me/903222286464"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/25 text-white px-8 py-4 rounded-full text-base font-bold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center" />
            WhatsApp'tan Yaz
          </a>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap justify-center gap-6 mt-14 text-center">
          {[
            { value: '500+', label: 'Mutlu Müşteri' },
            { value: '1000+', label: 'Tasarım' },
            { value: '5★', label: 'Puan' },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col gap-0.5">
              <span className="text-white font-black text-2xl md:text-3xl" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
                {stat.value}
              </span>
              <span className="text-white/40 text-xs font-medium uppercase tracking-wide">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/40 animate-bounce">
        <i className="ri-arrow-down-line text-xl w-5 h-5 flex items-center justify-center" />
        <span className="text-xs tracking-widest uppercase">Keşfet</span>
      </div>
    </section>
  );
}
